<h2 mat-dialog-title>Locate Package</h2>

<mat-dialog-content class="lookup-content">

  <mat-form-field appearance="outline" class="full">
    <mat-label>Item code or Serial #</mat-label>
    <input matInput [(ngModel)]="searchTerm"
           (keyup.enter)="search()" />
  </mat-form-field>

  <button mat-raised-button color="primary"
          (click)="search()" [disabled]="!searchTerm">
    <mat-icon>search</mat-icon>
    Search
  </button>

  <mat-progress-bar *ngIf="loading"
                    mode="indeterminate"
                    class="mt16"></mat-progress-bar>

  <mat-selection-list *ngIf="!loading && results.length">
    <mat-list-option *ngFor="let m of results"
                     (click)="select(m)">
      {{ m.product_code }}
      <span *ngIf="m.product_serial_number">
        — {{ m.product_serial_number }}
      </span>
    </mat-list-option>
  </mat-selection-list>

  <p class="muted" *ngIf="searched && !loading && !results.length">
    No matching packages found.
  </p>
</mat-dialog-content>
